const data = [
  {
    title: {
      home: 'Giving time',
      memberHome: 'Give time',
      spendPartnerHome: 'Give time',
      earnGroupHome: 'Give time',
      commissioner: 'Give time',
      FAQs: 'Give time',
    },
    description: {
      home:
        'People help out or volunteer in community groups, organisations or services in the Tempo network',
      memberHome:
        'Help out or volunteer in community groups and organisations in the Tempo network',
      spendPartnerHome:
        'People help out or volunteer in community groups or services that are part of the Tempo network',
      earnGroupHome:
        'Volunteers, community members and service users give their time to your organisation',
      commissioner:
        'People help out or volunteer in community groups, organisations or services in the Tempo network',
      FAQs:
        'People help out or volunteer in community groups, organisations or services in the Tempo network',
    },
    image: 'howTCWorkGiveTime',
  },
  {
    title: {
      home: 'Earning Tempo Time Credits',
      memberHome: 'Earning Tempo Time Credits',
      spendPartnerHome: 'Earning Tempo Time Credits',
      earnGroupHome: 'Earning Tempo Time Credits',
      commissioner: 'Earning Tempo Time Credits',
      FAQs: 'Earning Tempo Time Credits',
    },
    description: {
      home: 'People earn Time Credits as a thank you for their time',
      memberHome: 'You’ll earn Tempo Time Credits as a thank you for your time',
      spendPartnerHome: 'People earn Time Credits as a thank you for giving their time',
      earnGroupHome: 'You offer them Time Credits as a thank you',
      commissioner: 'People earn Time Credits as a thank you for their time',
      FAQs: 'People earn Time Credits as a thank you for their time',
    },
    image: 'howTCWorkSpend',
  },

  {
    title: {
      home: 'Spending Tempo Time Credits',
      memberHome: 'Spending Tempo Time Credits',
      spendPartnerHome: 'Spending Tempo Time Credits',
      earnGroupHome: 'Spending Tempo Time Credits',
      commissioner: 'Spending Tempo Time Credits',
      FAQs: 'Spending Tempo Time Credits',
    },
    description: {
      home:
        'People can spend Time Credits on a wide range of activities, through our national network of spend partners',
      memberHome:
        'Treat yourself or get together with friends and family - our national spend network has something for everyone',
      spendPartnerHome:
        'Time Credits can be spent on a wide range of activities, through our national network of spend partners',
      earnGroupHome:
        'They spend them on activities with our national network of partners, can treat others, or enjoy group social activities',
      commissioner:
        'People can spend Time Credits on a wide range of activities, through our national network of spend partners',
      FAQs:
        'People can spend Time Credits on a wide range of activities, through our national network of spend partners',
    },
    image: 'howTCWorkEarn',
  },
];

export default data;
